var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.469519 10.4695L0.469506 10.4695C0.399837 10.5391 0.344572 10.6219 0.306867 10.7129C0.269162 10.8039 0.249756 10.9015 0.249756 11C0.249756 11.0985 0.269162 11.1961 0.306867 11.2871C0.344572 11.3782 0.399837 11.4609 0.469506 11.5305C0.539178 11.6002 0.621889 11.6555 0.712914 11.6932C0.803941 11.7309 0.901505 11.7503 1.00003 11.7503C1.09856 11.7503 1.19613 11.7309 1.28715 11.6932C1.37818 11.6555 1.46089 11.6002 1.53056 11.5305L6.53046 6.53063C6.53049 6.5306 6.53053 6.53056 6.53056 6.53053C6.60025 6.4609 6.65553 6.37821 6.69326 6.28721C6.731 6.19616 6.75043 6.09856 6.75043 6C6.75043 5.90144 6.731 5.80385 6.69326 5.7128C6.65553 5.62179 6.60025 5.53911 6.53056 5.46948C6.53053 5.46944 6.53049 5.46941 6.53046 5.46938L1.53056 0.469477C1.38986 0.328772 1.19902 0.249725 1.00003 0.249725C0.801048 0.249725 0.610211 0.328772 0.469507 0.469477C0.328802 0.610181 0.249756 0.801018 0.249756 1C0.249756 1.19899 0.328802 1.38983 0.469507 1.53053L0.469519 1.53054L4.93958 6L0.469519 10.4695Z",
    fill: "#FF7A2A",
    stroke: "#FF7A2A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCard);
export default __webpack_public_path__ + "static/media/arrowCard.dbc3fabec72434f5b93a01a3d255a645.svg";
export { ForwardRef as ReactComponent };